import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Filter, Pageable, RestClientPaged } from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { environment } from '../../../../environments/environment'
import { ProductionCode } from './production-code'

export class ProductionCodeFilter {
  public static labels(labels: string[]): Filter {
    return new Filter('labels', labels)
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProductionCodeService extends RestClientPaged<ProductionCode, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/production-codes', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public findAllByLabels(labels: string[]): Observable<ProductionCode[]> {
    return this.findAllPaged(new Pageable(0, 100), [ProductionCodeFilter.labels(labels)]).pipe(
      map((page) => page.content)
    )
  }

  public patch(patch: ProductionCode): Observable<ProductionCode> {
    return super.patchInternal(patch.id, patch)
  }
}
